import { useEffect, useState } from 'react'
import { Form, Button, InputGroup, Spinner } from 'react-bootstrap'
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { error, success, getApiMessage } from "../../../notify";

const ResetPassword = () => {
   let history = useNavigate()
   const ERR_NETWORK_MESSAGE = 'Server is not available.'
   const token = sessionStorage.getItem("revizeTrainingToken");
   const resetPasswordApi = `${process.env.REACT_APP_SERVER_URL}/api/user/resetPassword/?user_id=`;
   const [userId, setUserId] = useState(0);

   const [password, setPassword] = useState("")
   const [confirmPassword, setConfirmPassword] = useState("")
   const [passwordError, setPasswordError] = useState("")
   const [confirmPasswordError, setConfirmPasswordError] = useState("")
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [showPassword, setShowPassword] = useState(false);
   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

   const handlePasswordInput = (event) => {
      setPassword(event.target.value);
      if (passwordError) setPasswordError("");
   };

   const handleConfirmPasswordInput = (event) => {
      setConfirmPassword(event.target.value);
      if (confirmPasswordError) setConfirmPasswordError("");
   };

   const validatePassword = () => {
      if (password === "") {
          setPasswordError("Password is mandatory");
          return false;
      }
      if (confirmPassword !== "" && password !== confirmPassword) {
          setConfirmPasswordError("Password and confirm password is not matching");
          return false;
      }
      setPasswordError("");
      if (confirmPassword !== "" && password === confirmPassword) {
          setConfirmPasswordError("");
      }
      return true;
   }

   const validateConfirmPassword = () => {
      if (confirmPassword === "") {
          setConfirmPasswordError("Confirm Password is mandatory");
          return false;
      }
      if (password !== confirmPassword) {
          setConfirmPasswordError("Password and confirm password is not matching");
          return false;
      }
      setConfirmPasswordError("");
      return true;
   }

   useEffect(() => {
      if (!token) {
         history('/auth/sign-in');
      }
      const urlParams = new URLSearchParams(window.location.search);
      const id = parseInt(urlParams.get("userId"), 10);
      if (id > 0) {
         setUserId(id);
      }
   }, [token, history])
  
   const formSubmit = (event) => {
      event.preventDefault();
      if (isSubmitting || !userId) return;

      const passwordOk = validatePassword();
      const confirmOk = validateConfirmPassword();
      if (!passwordOk || !confirmOk) return;

      const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
      var data = JSON.stringify({ "newPassword": password, "website_id": 0 });
      setIsSubmitting(true);

      axios.put(resetPasswordApi + userId, data, { headers: headers })
      .then((response) => {
         success(getApiMessage(response.data, "Password updated successfully"), true);
         setPassword("");
         setConfirmPassword("");
         event.target.reset();
      })
      .catch((err) => {
         if (err === 'ERR_NETWORK') {
             error(ERR_NETWORK_MESSAGE, true)
         } else {
             const detail = err && err.response && err.response.data
                ? err.response.data.detail || err.response.data.message || err.response.data
                : null;
             error(detail || "Unable to update password", true)
         }
      })
      .finally(() => {
         setIsSubmitting(false);
      });
   };

   const areAllFieldsFilled = password !== "" && confirmPassword !== "" && passwordError === "" && confirmPasswordError === "";

   return (
      <div className="revize-reset-password-page">
         <div className="revize-reset-password-card">
            <h2>Reset Password</h2>
            <p style={{ color: '#6b7280', fontSize: '16px', marginTop: '10px', marginBottom: '32px', lineHeight: 1.5 }}>
               Enter a new password for your account.
            </p>
            <Form onSubmit={formSubmit}>
               <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <InputGroup>
                     <Form.Control
                        style={{ borderColor: passwordError ? "#e55353" : undefined }}
                        type={showPassword ? "text" : "password"}
                        value={password}
                        id="password"
                        placeholder="Password"
                        onChange={handlePasswordInput}
                        onBlur={validatePassword}
                        maxLength={200}
                        disabled={isSubmitting}
                     />
                     <Button type="button" variant="outline-secondary" className="revize-eye-btn" onClick={() => setShowPassword(!showPassword)} disabled={isSubmitting}>
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                     </Button>
                  </InputGroup>
                  {passwordError ? <div style={{ color: "#e55353", fontSize: "12px", marginTop: "6px" }}>{passwordError}</div> : null}
               </Form.Group>

               <Form.Group className="mb-3">
                  <Form.Label>Confirm Password</Form.Label>
                  <InputGroup>
                     <Form.Control
                        style={{ borderColor: confirmPasswordError ? "#e55353" : undefined }}
                        type={showConfirmPassword ? "text" : "password"}
                        value={confirmPassword}
                        id="confirm-password"
                        placeholder="Confirm Password"
                        onChange={handleConfirmPasswordInput}
                        onBlur={validateConfirmPassword}
                        maxLength={200}
                        disabled={isSubmitting}
                     />
                     <Button type="button" variant="outline-secondary" className="revize-eye-btn" onClick={() => setShowConfirmPassword(!showConfirmPassword)} disabled={isSubmitting}>
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                     </Button>
                  </InputGroup>
                  {confirmPasswordError ? <div style={{ color: "#e55353", fontSize: "12px", marginTop: "6px" }}>{confirmPasswordError}</div> : null}
               </Form.Group>

               <Button
                  disabled={!areAllFieldsFilled || isSubmitting || !userId}
                  type="submit"
                  variant="primary"
                  aria-busy={isSubmitting}
               >
                  {isSubmitting ? (
                     <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                        Updating...
                     </>
                  ) : "Update"}
               </Button>
            </Form>
         </div>
      </div>
   )
}

export default ResetPassword
